import React from "react";
import { withRouter } from "react-router-dom";
import withShipment from "./withShipment";
import { hideError } from "./redux/actions/global";

// The Hive shell scrolls inside .shipment-background (an overflow-y:auto
// container), so window.scrollTo alone can't reset it. On every route change
// scroll the window AND the known scroll containers back to the top, so
// opening any app / screen always starts from the top.
class ScrollToTop extends React.Component {
    scrollAllToTop() {
        try {
            window.scrollTo(0, 0);
        } catch (e) {
            /* no-op */
        }
        ['.shipment-background', '.hive-content'].forEach((sel) => {
            const el = typeof document !== 'undefined' ? document.querySelector(sel) : null;
            if (el) el.scrollTop = 0;
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.scrollAllToTop();
            // Errors surface in a single global ErrorFeedbackBar that persists in
            // Redux until dismissed. Without this, a "Server Failed" raised on one
            // screen keeps showing after you navigate to an unrelated screen (e.g.
            // Document Center) that never made a failing call. Scope the error to
            // the screen that caused it by clearing it on every navigation.
            if (typeof this.props.hideError === 'function') {
                this.props.hideError();
            }
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(
    withShipment(
        {
            mapStateToProps: () => ({}),
            actionCreators: { hideError },
        },
        ScrollToTop
    )
);
